import React from "react";
import { Box, DialogActions, Typography } from "@mui/material";
import { commandKeyLabel } from "../../shared/platform";

// Small key-cap chip for the desktop shortcut hint.
const kbdSx = {
  fontSize: 11,
  fontFamily: "monospace",
  lineHeight: 1.6,
  px: 0.75,
  py: 0.25,
  mx: 0.25,
  minWidth: 20,
  textAlign: "center",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1,
  bgcolor: "rgba(0,0,0,0.04)",
  color: "text.secondary",
};

// Desktop-only discoverability hint for the keyboard shortcut that opens the
// launchpad from anywhere. Touch users have no keyboard, so the caller renders
// this only off mobile.
export default function DashboardShortcutHint() {
  return (
    <DialogActions
      sx={{
        px: 3,
        py: 1.5,
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: 12, color: "text.secondary", mr: 1 }}>
        Open anywhere with
      </Typography>
      <Box component="kbd" sx={kbdSx}>
        {commandKeyLabel}
      </Box>
      <Box component="kbd" sx={kbdSx}>
        K
      </Box>
    </DialogActions>
  );
}
